import Vue from "vue";
import Router from "vue-router";
import { store } from "../store";

import { mapActions } from "vuex";

import { userService } from "../services";

import HomePage from "../views/HomePage.vue";
import LoginPage from "../views/LoginPage.vue";
import ChangePassword from "@/components/ChangePassword.vue";

import ConfigGeneral from "@/components/config/configuraciongeneral.vue";

import Empresas from "@/components/crud/empresas.vue";
import Usuarios from "@/components/crud/usuarios.vue";
import Sucursales from "@/components/crud/sucursales.vue";
import GruposComerciales from "@/components/crud/gruposComerciales.vue";
import CanalesVenta from "@/components/crud/canalesVenta.vue";
import Productos from "@/components/crud/productos.vue";
import PoliticasComerciales from "@/components/crud/politicasComerciales.vue";
import Planes from "@/components/crud/planes.vue";
import TablasCoeficientes from "@/components/crud/tablasCoeficientes.vue";
import TablasCoeficientesCargos from "@/components/crud/tablasCoeficientesCargos.vue";
import LegajoPersona from "@/components/legajo/layout.vue";
import LegajoPersonaJuridica from "@/components/legajo/personaJuridicaLayout.vue";
import Empleadores from "@/components/crud/empleadores.vue";
import Feriados from "@/components/crud/feriados.vue";
import Requisitos from "@/components/crud/requisitos.vue";
import Seguridad from "@/components/crud/seguridad.vue";
import Cargos from "@/components/crud/cargos.vue";
import FormasLlegada from "@/components/crud/formasLlegada.vue";
import SituacionesLaborales from "@/components/crud/situacionesLaborales.vue";
import TareasGestion from "@/components/crud/tareasGestion.vue";
import RespuestasGestion from "@/components/crud/respuestasGestion.vue";
import Cajas from "@/components/crud/cajas.vue";
import ConceptosMovimientoCaja from "@/components/crud/conceptosmovimientocaja.vue";
import ModelosSMS from "@/components/crud/modelosSMS.vue";
import EstudiosExternos from "@/components/crud/estudiosExternos.vue";
import Inversores from "@/components/crud/inversores.vue";
import MotivosRechazo from "@/components/crud/motivosrechazo.vue";
import MotivosSolicitud from "@/components/crud/motivosdesolicitud.vue";
import MotivosDenuncia from "@/components/crud/motivosdenuncia.vue";
import Roles from "@/components/crud/roles.vue";
import CanalesConsulta from "@/components/crud/canalesConsulta.vue";
import MotivosTicket from "@/components/crud/motivosTicket.vue";
import GruposCaja from "@/components/crud/gruposCaja.vue";
import ProveedoresFirmaDigital from "@/components/crud/proveedoresFirmaDigital.vue";
import MotivosProspecto from "@/components/crud/motivosProspecto.vue";
//creditos y consultas
import ManejoSolicitudes from "@/components/creditos/ManejoSolicitudes.vue";
import ManejoCreditosOtorgados from "@/components/creditos/ManejoCreditosOtorgados.vue";
import ManejoConsultasCredito from "@/components/creditos/ManejoConsultas.vue";
import ManejoConsultasExternas from "@/components/creditos/ManejoConsultasExternas.vue";
import AltaCreditosFull from "@/components/creditos/AltaCreditosFull.vue";
import AltaConsultaCredito from "@/components/creditos/AltaConsultaCredito.vue";
import AltaConsultaCreditoV2 from "@/components/creditos/AltaConsultaCreditoV2.vue";
import AltaConsultaComercio from "@/components/creditos/AltaConsultaComercio.vue";
import ManejoProspectos from "@/components/prospectos/ManejoProspectos.vue";
import ManejoConsulta from "@/components/consultas/ManejoConsulta.vue";
import ConsultaMasiva from "@/components/creditos/ConsultaMasiva.vue";
//import ManejoOfertas from '@/components/ofertas/ManejoOfertas.vue'
import CambioEstadoMasivo from "@/components/creditos/CambioEstadoMasivo.vue";
import ManejoCreditosComercios from "@/components/creditos/ManejoCreditosComercios.vue";

//backoffice
import ManejoTransferencias from "@/components/creditos/ManejoTransferencias.vue";
import ManejoLiquidacionesComercio from "@/components/creditos/ManejoLiquidacionesComercio.vue";
import GeneracionArchivoDebitos from "@/components/debitos/generacionArchivo.vue";
import ImportacionArchivoDebitos from "@/components/debitos/importacionArchivo.vue";
import GeneracionArchivoDebitosTarjeta from "@/components/debitos/generacionArchivoTarjeta.vue";
import BotonSmsCumple from "@/components/common/BotonSmsCumple.vue";
import UpdateDatosDebito from "@/components/debitos/updateDatosParaDebito.vue";
import FormBaseAnsesPersonasJuridicas from "@/components/FormBaseAnsesPersonasJuridicas.vue";
import ProcesoMensualPaginasAmarillas from "@/components/ProcesoPaginasAmarillas.vue";
import FormBaseAnsesPersonasFisicas from "@/components/FormBaseAnsesPersonasFisicas.vue";
import CorreccionesPuntuales from "@/components/backoffice/correccionespuntuales.vue";
import AprobarCreditosSMS from "@/components/common/AprobarCreditosSMS.vue";
import ImportacionPadronIngresosBruto from "@/components/backoffice/ImportacionPadronIngresosBruto.vue";
import ArchivoInaes from "@/components/backoffice/archivoInaes.vue";
import GeneracionCuotasCuponizate from "@/components/common/GeneracionCuotasCuponizate.vue";
import PasarDebitarAimpactar from "@/components/debitos/pasarDebitarAimpactar.vue";
import Impactos from "@/components/backoffice/impactos.vue";
import ActualizacionBasePrefijos from "@/components/backoffice/actualizacionBasePrefijos.vue";

//caja
import ModuloCaja from "@/components/caja/layout.vue";
import ModuloCajaControl from "@/components/caja/control.vue";

import ManejoComprobantesInternos from "@/components/comprobantes/ManejoComprobantesInternos.vue";
import ManejoComprobantesFiscales from "@/components/comprobantes/ManejoComprobantesFiscales.vue";
import ManejoComprobantesPendientes from "@/components/comprobantes/ComprobantesFiscalesPendientes.vue";
import AltaMasivaNotasCredito from "@/components/comprobantes/AltaMasivaNotasCredito.vue";

//gestion
import AsignacionAGestores from "@/components/gestion/asignacionAGestores.vue";
import AsignacionAEstudios from "@/components/gestion/asignacionAEstudios.vue";

import GestionMora from "@/components/gestion/gestionMora.vue";

import AltaAcuerdo from "@/components/creditos/AltaAcuerdo.vue";
import AltaAcuerdoV2 from "@/components/creditos/AltaAcuerdoV2.vue";
import ManejoAcuerdos from "@/components/creditos/ManejoAcuerdos.vue";

import AltaGestionMasiva from "@/components/gestion/AltaGestionMasiva.vue";
import DesgravacionImpositiva from "@/components/gestion/DesgravacionImpositiva.vue";
import ManejoReclamos from "@/components/gestion/ManejoReclamos.vue";
import RespuestasGestionDetalle from "@/components/crud/respuestasGestionDetalle.vue";

import ProcesoTelefonosValidados from "@/components/gestion/procesoTelefonosValidados.vue";

import ManejoDenuncias from "@/components/gestion/ManejoDenuncias.vue";
import CampaniaSMSmarketing from "@/components/gestion/CampaniaSMSmarketing.vue";
//venta de cartera
import ManejoVentaCartera from "@/components/ventacartera/ManejoVentaCartera.vue";

// reporting
import ReportesOperativos from "@/components/reporting/ReportViewer.vue";
import ReportesTest from "@/components/reporting/ReportViewerTest.vue";
import ReportViewer from "@/components/reporting/ReportViewer.vue";

import ReportingSubdiarioCobranzas from "@/components/reporting/subdiariocobranzas.vue";
import ReportingVentas from "@/components/reporting/ventas.vue";
import ReportingImpactosPorCredito from "@/components/reporting/impactosporcredito.vue";
import ReportingConsultas from "@/components/reporting/consultas.vue";
import ReportingCreditos from "@/components/reporting/creditos.vue";

import ReportingproductosAEntregar from "@/components/reporting/ProductosAEntregar.vue";

import ReportingCreditosParaRenovar from "@/components/reporting/creditospararenovar";
import ReportingCanceladosQueNoRenovaron from "@/components/reporting/canceladosquenorenovaron";
import ReportingCorreccionesPuntuales from "@/components/reporting/reportecorreccionespuntuales";
import ReportingTarjetasVencidas from "@/components/reporting/reportetarjetasvencidas";

import ReportingMovimientosCaja from "@/components/reporting/movimientoscaja.vue";
import ReportingEvolucionSaldosCaja from "@/components/reporting/evolucionsaldoscaja.vue";
import ReportingSubdiarioIvaVentas from "@/components/reporting/subdiarioIvaVentas.vue";

import ReportingEstadosLegajosFisicos from "@/components/reporting/estadoslegajosfisicos.vue";
import ReportingIngresosUsuarios from "@/components/reporting/ingresosusuarios.vue";
import ReportingBoletinSiisa from "@/components/reporting/boletinsiisa.vue";
import ReportingEnvioSiisa from "@/components/reporting/enviosiisa.vue";
import ReportingEnvioBcra from "@/components/reporting/enviobcra.vue";
import ReportingEnvioSms from "@/components/reporting/enviosms.vue";
import ReportingInteraccionGueno from "@/components/reporting/interacciongueno.vue";
import ReportingInteraccionDigiventures from "@/components/reporting/interacciondigiventures.vue";
import ReportingEnvioVeraz from "@/components/reporting/envioveraz.vue";
import ReportingVentasAcumuladas from "@/components/reporting/ventasacumuladas.vue";
import ReportingEstadosCreditos from "@/components/reporting/creditosestados.vue";
import ReportingCobroPorDebito from "@/components/reporting/cobrospordebito.vue";
import ReportingReclamos from "@/components/reporting/reclamos.vue";
import ReportingTransferencias from "@/components/reporting/transferencias.vue";
import ReportingListadoRegistrosApp from "@/components/reporting/listadoregistrosapp.vue";
import ReportingListadoInformesPagoViaApp from "@/components/reporting/listadoinformespagoviaapp.vue";
import ReportingCobranzas from "@/components/reporting/cobranzas.vue";
import ReportingCashFlow from "@/components/reporting/cashflow.vue";
import ReportingVentasAcumuladasComercios from "@/components/reporting/ventasacumuladascomercios.vue";
import ReportingAnulaciones from "@/components/reporting/anulaciones.vue";
import ReportingCancelacionCuotaEnViaje from "@/components/reporting/cancelacioncuotaenviaje.vue";

// bases
import ReportingBaseCompletaDiaria from "@/components/reporting/basecompletadiaria.vue";
import ReportingBaseCambiosEstadoCreditos from "@/components/reporting/basecambiosestadocreditos.vue";
import ReportingBaseIVR from "@/components/reporting/baseivr.vue";
import ReportingBaseDetalladaSituacion from "@/components/reporting/basedetalladasituacion.vue";
import ReportingBaseRecuperoPorEstudio from "@/components/reporting/baserecuperoporestudio.vue";
import ReportingBaseArgencobrosyMoraTardia from "@/components/reporting/baseargencobrosymoratardia.vue";
import ReportingBaseGestiones from "@/components/reporting/basegestiones.vue";
import ReportingBaseAsignaciones from "@/components/reporting/baseasignaciones.vue";
import ReportingBaseCreditosActivos from "@/components/reporting/basecreditosactivos.vue";
import ReportingBaseCarteraDetalladaCompleta from "@/components/reporting/basecarteradetalladacompleta.vue";
import ReportingBaseReclamos from "@/components/reporting/basereclamos.vue";
import ReportingBaseUltimasRespuestasDebito from "@/components/reporting/baseultimasrespuestasdebito.vue";
import ReportingBaseReporteProspectos from "@/components/reporting/basereporteprospectos.vue";
import ReportingBaseReporteConsultas from "@/components/reporting/basereporteconsultas.vue";
import ReportingBaseCastigos from "@/components/reporting/basecastigosytelegramas.vue";
import ReportingBaseRespaldatorioEnvios from "@/components/reporting/baserespaldatoriosenvios.vue";
import ReportingBaseCantidadCreditos from "@/components/reporting/basecantidadcreditos.vue";
import ReportingBaseAsociadosMutual from "@/components/reporting/asociadosmutual.vue";
import ReportingBasesBeneficiosAnses from "@/components/reporting/basebeneficiosanses.vue";
import ReportingBasesConsultasConCelular from "@/components/reporting/baseconsultasconcelular.vue";

import LinksExternos from "@/components/common/LinksExternos.vue";

//carga rapida comers
import LoginCargaRapida from "../components/cargarapidacomer/LoginCargaRapida.vue";
import AdjuntarDocumentacionComer from "../components/cargarapidacomer/AdjuntarDocumentacion.vue";

// coin
import FormularioPagoCoin from "@/components/coin/FormularioPago.vue";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", component: HomePage },
    { path: "/login", component: LoginPage },
    {
      path: "/changePassword/",
      component: ChangePassword,
      name: "changePassword",
      props: true,
    },
    {
      path: "/config-general",
      component: ConfigGeneral,
      name: "configgeneral",
    },
    {
      path: "/empresas-crud",
      component: Empresas,
      name: "empresas",
    }, //{ path: '/empresas-crud', component: Empresas, name: 'empresas', beforeEnter: requireAuth },
    {
      path: "/usuarios-crud",
      component: Usuarios,
      name: "usuarios",
    },
    {
      path: "/sucursales-crud",
      component: Sucursales,
      name: "sucursales",
    },
    {
      path: "/gruposcomerciales-crud",
      component: GruposComerciales,
      name: "gruposComerciales",
    },
    {
      path: "/canalesventa-crud",
      component: CanalesVenta,
      name: "canalesVenta",
    },
    {
      path: "/productos-crud",
      component: Productos,
      name: "productos",
    },
    {
      path: "/politicascomerciales-crud",
      component: PoliticasComerciales,
      name: "politicasComerciales",
    },
    { path: "/planes-crud", component: Planes, name: "planes" },
    {
      path: "/tablascoeficientes-crud",
      component: TablasCoeficientes,
      name: "tablasCoeficientes",
    },
    {
      path: "/tablascoeficientescargos-crud",
      component: TablasCoeficientesCargos,
      name: "tablasCoeficientesCargos",
    },
    {
      path: "/legajo-persona/:personaId",
      component: LegajoPersona,
      name: "legajopersona",
      props: true,
    },
    {
      path: "/legajo-persona-juridica/:personaId",
      component: LegajoPersonaJuridica,
      name: "legajopersonaJuridica",
      props: true,
    },
    {
      path: "/empleadores-crud",
      component: Empleadores,
      name: "empleadores",
    },
    {
      path: "/feriados-crud",
      component: Feriados,
      name: "feriados",
    },
    {
      path: "/requisitos-crud",
      component: Requisitos,
      name: "requisitos",
    },
    {
      path: "/seguridad-crud",
      component: Seguridad,
      name: "seguridad",
    },
    { path: "/cargos-crud", component: Cargos, name: "cargos" },
    {
      path: "/formasllegada-crud",
      component: FormasLlegada,
      name: "formasLlegada",
    },
    {
      path: "/situacioneslaborales-crud",
      component: SituacionesLaborales,
      name: "situacionesLaborales",
    },
    {
      path: "/tareasgestion-crud",
      component: TareasGestion,
      name: "tareasGestion",
    },
    {
      path: "/respuestasgestion-crud",
      component: RespuestasGestion,
      name: "respuestasGestion",
    },
    { path: "/cajas-crud", component: Cajas, name: "cajas" },
    {
      path: "/conceptosmovimientocaja-crud",
      component: ConceptosMovimientoCaja,
      name: "conceptosMovimientoCaja",
    },
    {
      path: "/modelossms-crud",
      component: ModelosSMS,
      name: "modelosSMS",
    },
    {
      path: "/estudiosexternos-crud",
      component: EstudiosExternos,
      name: "estudiosExternos",
    },
    {
      path: "/inversores-crud",
      component: Inversores,
      name: "inversores",
    },
    {
      path: "/motivos-rechazo-crud",
      component: MotivosRechazo,
      name: "motivosrechazo",
    },
    {
      path: "/motivos-solicitud-crud",
      component: MotivosSolicitud,
      name: "motivossolicitud",
    },
    {
      path: "/estados-debito-denuncia-crud",
      component: MotivosDenuncia,
      name: "motivosdenuncia",
    },
    {
      path: "/roles-crud",
      component: Roles,
      name: "rolesusuario",
    },
    {
      path: "/canales-consulta-crud",
      component: CanalesConsulta,
      name: "canalesconsulta",
    },
    {
      path: "/motivo-ticket-crud",
      component: MotivosTicket,
      name: "motivosticket",
    },

    {
      path: "/grupo-caja-crud",
      component: GruposCaja,
      name: "gruposcaja",
    },
    {
      path: "/proveedores-firma-digital-crud",
      component: ProveedoresFirmaDigital,
      name: "proveedoresFirmaDigital",
    },
    {
      path: "/motivos-prospecto-crud",
      component: MotivosProspecto,
      name: "motivosProspecto",
    },

    //creditos y consultas
    {
      path: "/manejoconsultas",
      component: ManejoConsultasCredito,
      name: "manejoConsultas",
    },
    {
      path: "/manejoconsultasExternas",
      component: ManejoConsultasExternas,
      name: "manejoConsultasExternas",
    },
    {
      path: "/manejosolicitudes",
      component: ManejoSolicitudes,
      name: "manejoSolicitudes",
    },
    {
      path: "/manejocreditosotorgados",
      component: ManejoCreditosOtorgados,
      name: "manejoCreditosOtorgados",
    },

    {
      path: "/alta-creditos-full",
      component: AltaCreditosFull,
      name: "altacreditosfull",
    },
    {
      path: "/alta-consulta-credito",
      component: AltaConsultaCredito,
      name: "altaconsultacredito",
    },
    {
      path: "/alta-consulta-credito/:retomarConsultaId",
      component: AltaConsultaCredito,
      name: "altaconsultacredito",
      props: true,
    },

    {
      path: "/alta-consulta-credito-v2",
      component: AltaConsultaCreditoV2,
      name: "altaconsultacreditov2",
    },
    {
      path: "/alta-consulta-credito-v2/:retomarConsultaId",
      component: AltaConsultaCreditoV2,
      name: "altaconsultacreditov2",
      props: true,
    },

    {
      path: "/alta-consulta-comercio/:retomarConsultaId?",
      component: AltaConsultaComercio,
      name: "altaconsultacreditocomercio",
      props: true,
    },
    {
      path: "/consulta-masiva",
      component: ConsultaMasiva,
      name: "consultaMasiva",
    },
    {
      path: "/manejo-creditos-comercios",
      component: ManejoCreditosComercios,
      name: "manejocreditoscomerios",
    },
    //{ path: '/manejo-ofertas', component: ManejoOfertas, name: 'manejoofertas' },

    //backoffice
    {
      path: "/manejotransferencias",
      component: ManejoTransferencias,
      name: "manejotransferencias",
    },
    {
      path: "/manejo-liquidaciones-comercio",
      component: ManejoLiquidacionesComercio,
      name: "manejoliquidacionescomercio",
    },
    {
      path: "/generacion-archivo-debitos",
      component: GeneracionArchivoDebitos,
      name: "generacionarchivodebito",
    },
    {
      path: "/importacion-archivo-debitos",
      component: ImportacionArchivoDebitos,
      name: "importacionarchivodebito",
    },
    {
      path: "/generacion-archivo-debitos-tarjeta",
      component: GeneracionArchivoDebitosTarjeta,
      name: "generacionarchivodebitotarjeta",
    },
    {
      path: "/boton-sms-cumple",
      component: BotonSmsCumple,
      name: "botonsmscumple",
    },
    {
      path: "/update-datos-debito",
      component: UpdateDatosDebito,
      name: "updatedatosdebito",
    },
    {
      path: "/form-base-anses-personas-juridicas",
      component: FormBaseAnsesPersonasJuridicas,
      name: "formbaseansespersonasjuridicas",
    },
    {
      path: "/proceso-mensual-paginas-amarillas",
      component: ProcesoMensualPaginasAmarillas,
      name: "procesomensualpaginasamarillas",
    },
    {
      path: "/form-base-anses-personas-fisicas",
      component: FormBaseAnsesPersonasFisicas,
      name: "formbaseansespersonasfisicas",
    },
    {
      path: "/correcciones-puntuales",
      component: CorreccionesPuntuales,
      name: "correccionespuntuales",
    },
    {
      path: "/generacion-archivo-inaes",
      component: ArchivoInaes,
      name: "archivoInaes",
    },
    {
      path: "/cambio-estado-masivo",
      component: CambioEstadoMasivo,
      name: "cambioestadomasivo",
    },
    {
      path: "/aprobar-creditos-sms",
      component: AprobarCreditosSMS,
      name: "aprobarcreditossms",
    },

    {
      path: "/importacion-padron-ingresos-bruto",
      component: ImportacionPadronIngresosBruto,
      name: "importacionPadronIngresosBruto",
    },
    {
      path: "/generacion-cuotas-cuponizate",
      component: GeneracionCuotasCuponizate,
      name: "GeneracionCuotasCuponizate",
    },
    {
      path: "/pasarDebitarAimpactar",
      component: PasarDebitarAimpactar,
      name: "PasarDebitarAimpactar",
    },
    {
      path: "/generacion-impactos",
      component: Impactos,
      name: "Impactos",
    },
    {
      path: "/actualizacion-base-prefijos",
      component: ActualizacionBasePrefijos,
      name: "actualizacionBasePrefijos",
    },

    //caja
    {
      path: "/modulo-caja",
      component: ModuloCaja,
      name: "moduloCaja",
    },
    {
      path: "/modulo-caja-control",
      component: ModuloCajaControl,
      name: "moduloCajaControl",
    },
    {
      path: "/manejo-comprobantes-internos",
      component: ManejoComprobantesInternos,
      name: "manejoComprobanteInternos",
    },
    {
      path: "/manejo-comprobantes-fiscales",
      component: ManejoComprobantesFiscales,
      name: "manejoComprobanteFiscales",
    },
    {
      path: "/manejo-comprobantes-pendientes",
      component: ManejoComprobantesPendientes,
      name: "manejoComprobantesPendientes",
    },
    {
      path: "/alta-masiva-notacredito",
      component: AltaMasivaNotasCredito,
      name: "altaMasivaNotaCredito",
    },

    //gestion
    {
      path: "/asignacion-estudios",
      component: AsignacionAEstudios,
      name: "asignacionaestudios",
    },

    {
      path: "/asignacion-gestores",
      component: AsignacionAGestores,
      name: "asignacionagestores",
    },
    {
      path: "/gestion-mora",
      component: GestionMora,
      name: "gestionMora",
    },

    {
      path: "/alta-acuerdo",
      component: AltaAcuerdo,
      name: "altaacuerdo",
    },
    {
      path: "/alta-acuerdo-v2",
      component: AltaAcuerdoV2,
      name: "altaacuerdov2",
    },
    {
      path: "/manejo-acuerdos",
      component: ManejoAcuerdos,
      name: "majejoacuerdos",
    },

    {
      path: "/alta-gestion-masiva",
      component: AltaGestionMasiva,
      name: "altagestionmasiva",
    },
    {
      path: "/desgravacion-impositiva",
      component: DesgravacionImpositiva,
      name: "desgravacionImpositiva",
    },
    {
      path: "/manejo-reclamos",
      component: ManejoReclamos,
      name: "manejoreclamos",
    },
    {
      path: "/manejo-consulta",
      component: ManejoConsulta,
      name: "manejoconsulta",
    },
    {
      path: "/respuestasgestiondetalle-crud",
      component: RespuestasGestionDetalle,
      name: "respuestasGestionDetalle",
    },
    {
      path: "/manejo-denuncias",
      component: ManejoDenuncias,
      name: "manejoDenuncias",
    },
    {
      path: "/campaniaSMSmarketing",
      component: CampaniaSMSmarketing,
      name: "campaniaSMSmarketing",
    },
    {
      path: "/procesoTelefonosValidados",
      component: ProcesoTelefonosValidados,
      name: "procesoTelefonosValidados",
    },

    //venta de cartera
    {
      path: "/manejo-venta-cartera",
      component: ManejoVentaCartera,
      name: "manejoventacartera",
    },

    //reporting
    {
      path: "/reportes-operativos",
      component: ReportesOperativos,
      name: "reportesOperativos",
    },
    {
      path: "/reportes-test",
      component: ReportesTest,
      name: "reportesTest",
      props: true,
    },
    {
      path: "/report-viewer",
      component: ReportViewer,
      name: "reportViewer",
      props: true,
    },

    {
      path: "/reporting-subdiario-cobranzas",
      component: ReportingSubdiarioCobranzas,
    },
    { path: "/reporting-ventas", component: ReportingVentas },
    {
      path: "/reporting-ventas-acumuladas",
      component: ReportingVentasAcumuladas,
    },
    {
      path: "/reporting-ventas-acumuladas-comercios",
      component: ReportingVentasAcumuladasComercios,
    },
    {
      path: "/reporting-impactos-por-credito",
      component: ReportingImpactosPorCredito,
    },
    {
      path: "/reporting-consultas",
      component: ReportingConsultas,
    },
    { path: "/reporting-creditos", component: ReportingCreditos },

    {
      path: "/reporting-productos-a-entregar",
      component: ReportingproductosAEntregar,
    },

    {
      path: "/reporting-subdiario-cobranzas",
      component: ReportingSubdiarioCobranzas,
    },
    {
      path: "/reporting-movimientos-cajas",
      component: ReportingMovimientosCaja,
    },
    {
      path: "/reporting-evolucion-saldos-caja",
      component: ReportingEvolucionSaldosCaja,
    },
    {
      path: "/reporting-subdiario-iva-ventas",
      component: ReportingSubdiarioIvaVentas,
    },
    {
      path: "/reporting-estados-legajos-fisicos",
      component: ReportingEstadosLegajosFisicos,
    },
    {
      path: "/reporting-ingresos-usuarios",
      component: ReportingIngresosUsuarios,
    },
    {
      path: "/reporting-creditos-para-renovar",
      component: ReportingCreditosParaRenovar,
    },
    {
      path: "/reporting-cancelados-no-renovaron",
      component: ReportingCanceladosQueNoRenovaron,
    },
    {
      path: "/reporting-correcciones-puntuales",
      component: ReportingCorreccionesPuntuales,
    },
    {
      path: "/reporting-tarjetas-vencidas",
      component: ReportingTarjetasVencidas,
    },

    {
      path: "/reporting-boletin-siisa",
      component: ReportingBoletinSiisa,
    },
    {
      path: "/reporting-envio-siisa",
      component: ReportingEnvioSiisa,
    },
    {
      path: "/reporting-envio-bcra",
      component: ReportingEnvioBcra,
    },
    {
      path: "/reporting-envio-sms",
      component: ReportingEnvioSms,
    },
    {
      path: "/reporting-gueno",
      component: ReportingInteraccionGueno,
    },
    {
      path: "/reporting-digiventures",
      component: ReportingInteraccionDigiventures,
    },
    {
      path: "/reporting-envio-veraz",
      component: ReportingEnvioVeraz,
    },
    {
      path: "/reporting-estados-creditos",
      component: ReportingEstadosCreditos,
    },
    {
      path: "/reporting-cobros-por-debito",
      component: ReportingCobroPorDebito,
    },
    { path: "/reporting-reclamos", component: ReportingReclamos },
    {
      path: "/reporting-transferencias",
      component: ReportingTransferencias,
    },
    {
      path: "/reporting-listado-registros-app",
      component: ReportingListadoRegistrosApp,
    },
    {
      path: "/reporting-listado-imformes-pago-app",
      component: ReportingListadoInformesPagoViaApp,
    },
    {
      path: "/reporting-cobranzas",
      component: ReportingCobranzas,
    },
    { path: "/reporting-cashflow", component: ReportingCashFlow },
    {
      path: "/reporting-anulaciones",
      component: ReportingAnulaciones,
    },
    {
      path: "/reporting-cancelacion-cuota-viaje",
      component: ReportingCancelacionCuotaEnViaje,
    },

    //bases
    {
      path: "/bases-completa-diaria",
      component: ReportingBaseCompletaDiaria,
      name: "basecompletadiaria",
    },
    {
      path: "/bases-cambios-estado-creditos",
      component: ReportingBaseCambiosEstadoCreditos,
      name: "basecambiosestadocreditos",
    },
    {
      path: "/bases-ivr",
      component: ReportingBaseIVR,
      name: "baseivr",
    },

    {
      path: "/bases-detallada-situacion",
      component: ReportingBaseDetalladaSituacion,
      name: "basedetalladasituacion",
    },
    {
      path: "/bases-argencobros-moratardia",
      component: ReportingBaseArgencobrosyMoraTardia,
      name: "baseargencobrosymoratardia",
    },
    {
      path: "/bases-recupero-estudio",
      component: ReportingBaseRecuperoPorEstudio,
      name: "baserecuperoporestudio",
    },
    {
      path: "/bases-gestiones",
      component: ReportingBaseGestiones,
      name: "basegestiones",
    },
    {
      path: "/bases-asignaciones",
      component: ReportingBaseAsignaciones,
      name: "baseasignaciones",
    },
    {
      path: "/bases-creditos-activos",
      component: ReportingBaseCreditosActivos,
      name: "basecreditosactivos",
    },
    {
      path: "/bases-cartera-detallada-completa",
      component: ReportingBaseCarteraDetalladaCompleta,
      name: "basecarteradetalladacompleta",
    },
    {
      path: "/bases-reclamos",
      component: ReportingBaseReclamos,
      name: "basereclamos",
    },
    {
      path: "/bases-ultimas-respuestas-debito",
      component: ReportingBaseUltimasRespuestasDebito,
      name: "baseultimasrespuestasdebito",
    },

    {
      path: "/reporte-prospectos",
      component: ReportingBaseReporteProspectos,
      name: "basereporteprospectos",
    },
    {
      path: "/reporte-consultas",
      component: ReportingBaseReporteConsultas,
      name: "basereporteconsultas",
    },
    {
      path: "/base-castigos",
      component: ReportingBaseCastigos,
      name: "basecastigosytelegramas",
    },
    {
      path: "/bases-respaldatorio-envios",
      component: ReportingBaseRespaldatorioEnvios,
      name: "baserespaldatorioenvios",
    },

    {
      path: "/manejo-prospectos",
      component: ManejoProspectos,
      name: "manejoprospectos",
    },
    {
      path: "/bases-cantidad-creditos",
      component: ReportingBaseCantidadCreditos,
      name: "basescantidadcreditos",
    },
    {
      path: "/bases-beneficios-anses",
      component: ReportingBasesBeneficiosAnses,
      name: "basebeneficiosanses",
    },
    {
      path: "/bases-consultas-celular",
      component: ReportingBasesConsultasConCelular,
      name: "baseconsultascelular",
    },
    {
      path: "/bases-asociados-mutual",
      component: ReportingBaseAsociadosMutual,
      name: "basesasociadosmutual",
    },
    {
      path: "/manejo-prospectos",
      component: ManejoProspectos,
      name: "manejoprospectos",
    },

    //coin
    {
      path: "/coin-test",
      component: FormularioPagoCoin,
      name: "formularioPagoCoin",
    },

    //LinksExternos
    {
      path: "/LinksExternos",
      component: LinksExternos,
      name: "linksExternos",
    },

    //carga rapida comer
    {
      path: "/logincargarapida",
      component: LoginCargaRapida,
      name: "loginCargaRapida",
    },
    {
      path: "/adjuntar-documentacion-comer",
      component: AdjuntarDocumentacionComer,
      name: "adjuntardocumentacioncomer",
      props: (route) => ({
        creditoId: route.query.creditoId,
        personaId: route.query.personaId,
        empresaId: route.query.empresaId,
      }),
    },

    {
      path: "/logout",
      beforeEnter(to, from, next) {
        userService.logout();
        next("/login");
      },
    },
    //{ path: '/', name: 'SignIn', component: LoginPage },
    { path: "*", redirect: "/" }, // Cualquier otra cosa, a la Home
  ],
});

export default router;

router.beforeEach((to, from, next) => {
  mapActions(["autoSignIn"]);
  // redirecciona al login si no se est� logueado y se est� accediendo a una p�gina restringida
  const publicPages = ["/login", "/changePassword", "/logincargarapida"]; // solo est�s p�ginas son publicas
  const authRequired = !publicPages.includes(to.path); // (todas las dem�s, no)
  const loggedIn = store.getters.user;
  //const loggedIn = localStorage.user;

  /* if(to.name == 'altaconsultacreditov2' && !from.name)
  {
    store.state.retomarConsultaId = to.params.retomarConsultaId;
  } */
  console.log(to.path);
  /*console.log('store')
  console.log(store)
  console.log('store user')
  console.log(store.getters.user);
  console.log('local storage user')
  console.log(localStorage.user)*/

  /*if(!store.getters.user && localStorage.user)
  {
    store.state.user = JSON.parse(JSON.stringify(localStorage.user));
    console.log('userSeteado');
    console.log(store.state.user);
    //store.actions.autoSignIn(localStorage.user);
    //commit('setUser',(JSON.stringify(localStorage.user)))
    //autoSignIn(localStorage.user);
  }*/

  if (authRequired && !loggedIn) {
    Vue.$log.debug(to.path);
    Vue.$log.debug("redireccionado a login...");
    store.state.redirect = to.path;

    //next({ name: 'login', query: { redirect: to.path } });
    return next("/login");
  } else next();
});
